<template>
  <div>
    <div class="app_overlay w-full h-screen" v-show="showItem"></div>
    <div class="row border-bottom white-bg notselectable">
      <nav
        class="navbar navbar-expand-lg navbar-static-top d-flex flex-md-row-reverse"
        role="navigation"
      >
        <div
          class="d-none d-lg-block navbar-collapse collapse px-0 py-2"
          id="navbar"
        >
          <!-- <a href="#" class="navbar-brand">{{ $user.model.name }}</a> -->
          <router-link class="navbar-brand" to="/"
            >{{
              $user.model && $user.model.name
                ? $user.model.name
                : $user.full_name
            }}
          </router-link>
          <ul class="nav navbar-nav mr-auto" v-if="permissionsLoaded">
            <li class="dropdown" v-for="(item, index) in menus" :key="index">
              <a
                v-if="item.childs && checkParentPermissions(item.childs)"
                aria-expanded="false"
                role="button"
                href="#"
                class="dropdown-toggle"
                data-toggle="dropdown"
              >
                {{ item.title }}
              </a>
              <ul
                v-if="item.childs && checkParentPermissions(item.childs)"
                role="menu"
                class="dropdown-menu"
              >
                <li
                  v-for="(child, childIndex) in getAllowedSubMenus(item.childs)"
                  :key="childIndex"
                >
                  <router-link :to="child.to">{{ child.title }}</router-link>
                </li>
              </ul>
              <router-link
                v-else-if="$acl.can('view', item.name)"
                :to="item.to"
                aria-expanded="false"
                role="button"
              >
                {{ item.title }}
              </router-link>
            </li>
          </ul>
          <ul
            class="nav navbar-top-links navbar-right d-flex justify-content-center align-items-center k-gap-6"
          >
            <li>
              <a href="/" @click.prevent="reloadApp">
                <div class="reload-app">
                  <i class="fas fa-sync"></i>
                  <span>بارگذاری مجدد</span>
                </div>
              </a>
            </li>
            <li
              class="dropdown ml-2 mr-4"
              v-if="$acl.isSuperAdmin || $acl.can('view', 'panel-sms')"
            >
              <a class="dropdown-toggle count-info" aria-expanded="false">
                <i class="fas fa-sms"></i>
                <span
                  class="label"
                  :class="{
                    'label-blue': smsCredit > 10000,
                    'label-danger': smsCredit < 10000,
                  }"
                  >{{ smsCredit }}</span
                >
              </a>
            </li>
            <li class="dropdown">
              <a
                class="dropdown-toggle count-info"
                data-toggle="dropdown"
                href="#"
                aria-expanded="false"
              >
                <i class="fas fa-user"></i>
                <!-- <span class="label label-primary"></span> -->
              </a>
              <ul class="dropdown-menu dropdown-alerts">
                <li>
                  <div class="text-center my-3">
                    خوش آمدید
                    {{ $user.name }}
                    {{ $user.family }}
                    <span class="label">{{
                      $user.type ? $user.type : "مدیر"
                    }}</span>
                    <!-- <span class="float-right text-muted small"></span> -->
                  </div>
                </li>
                <li class="dropdown-divider"></li>
                <li>
                  <div
                    class="text-center link-block"
                    @click="openChangePassword"
                  >
                    <a class="dropdown-item count-info">
                      <i class="fas fa-lock"></i>
                      <strong> تغییر رمز عبور </strong>
                    </a>
                  </div>
                </li>
              </ul>
            </li>

            <li>
              <a @click="signOut()">
                <i class="fa fa-sign-out-alt"></i>
              </a>
            </li>
          </ul>
        </div>

        <!-- mobile menu -->
        <!-- <div
          class="d-flex justify-content-between d-lg-none h-100 w-100 flex-row-reverse p-3 position-sticky top-0 mx-3"
          v-click-outside="handleCloseModal"
        >  -->
        <div
          class="d-flex justify-content-between d-lg-none h-100 w-100 flex-row-reverse p-3 position-sticky top-0 mx-3"
        >
          <!-- <a href="#" class="navbar-brand">{{ $user.model.name }}</a> -->
          <img src="../assets/img/icon.png" width="50" alt="" />
          <button
            class="navbar-toggler h-100 mr-0 pr-0"
            type="button"
            data-toggle="collapse"
            data-target="#navbar"
            aria-expanded="false"
            aria-label="Toggle navigation"
            @click="showItem = !showItem"
          >
            <i class="fa fa-bars"></i>
          </button>
        </div>
        <div
          :class="[
            'd-flex flex-column justify-content-start d-lg-none mobile-menu overflow-auto',
            { show: showItem },
          ]"
          v-show="showItem"
        >
          <div class="user-details-container pt-5 px-5 pb-1 position-relative">
            <div
              class="user-details__links-container close-btn"
              @click="showItem = false"
            >
              <i class="fa fa-times"></i>
            </div>
            <div
              class="d-flex flex-column justify-content-center align-items-center text-center"
            >
              <div class="user-avatar">
                <strong class="m-0 font-bold">
                  {{ chunkFullName }}
                </strong>
              </div>
              <h3 class="m-0 p-0 mt-2">{{ $user.full_name }}</h3>
              <!-- <p
                v-if="this.$acl.can('view', 'walletreportmanagements')"
                class="mt-2 m-0"
              >
                <span class="label label-primary user-details__balance">{{
                  $thousandSeprator(
                    userBalance / 1000 > 0 ? userBalance / 1000 : 0
                  )
                }}</span>
              </p> -->
              <div class="user-details__credentials mt-1">
                <p class="m-0">
                  {{ $user.type ? $user.type : "مدیر" }}
                </p>
              </div>
            </div>
          </div>

          <ul
            class="nav navbar-top-links navbar-right mobile-nav__links d-flex w-full p-0  my-3"
          >
            <router-link to="/reports/wr1" class="dropdown-item p-0">
              <div
                class="user-details__links-container"
                v-if="this.$acl.can('view', 'walletreportmanagements')"
              >
                <i class="fas fa-credit-card"></i>
              </div>
            </router-link>
            <div
              class="user-details__links-container mx-3"
              @click="openChangePassword"
            >
              <i class="fas fa-key"></i>
            </div>
            <div class="user-details__links-container" @click="signOut()">
              <i class="fa fa-sign-out-alt"></i>
            </div>
          </ul>
          <div class="d-flex justify-content-between pr-3">
            <ul class="nav navbar-nav mr-auto p-2" v-if="permissionsLoaded">
              <li
                class="dropdown my-2"
                v-for="(item, index) in menus"
                :key="index"
              >
                <a
                  aria-expanded="false"
                  role="button"
                  href="#"
                  class="dropdown-toggle"
                  data-toggle="dropdown"
                  v-if="item.childs && checkParentPermissions(item.childs)"
                >
                  {{ item.title }}
                </a>
                <ul
                  v-if="item.childs && checkParentPermissions(item.childs)"
                  role="menu"
                  class="dropdown-menu"
                >
                  <li
                    v-for="(child, childIndex) in getAllowedSubMenus(
                      item.childs,
                    )"
                    :key="childIndex"
                  >
                    <router-link :to="child.to">{{ child.title }}</router-link>
                  </li>
                </ul>
                <router-link
                  v-else-if="$acl.can('view', item.name)"
                  :to="item.to"
                  aria-expanded="false"
                  role="button"
                >
                  {{ item.title }}
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
    <charge-modal modal-id="charge" title="افزایش موجودی کیف پول" />
    <settings-modal :settings="settings" />
    <sms-modal />
    <change-passwrod />
  </div>
</template>
<script>
import ChargeModal from "./wallet/ChargeModal";
import SettingsModal from "./settings/SettingsModal";
import SmsModal from "./sms/SmsChargeModal";
import ChangePasswrod from "./settings/ChangePasswordModal.vue";

export default {
  components: {
    ChargeModal,
    SettingsModal,
    SmsModal,
    ChangePasswrod,
  },
  data() {
    return {
      showItem: false,
      menus: [
        {
          title: "مدیریت اعلام بار",
          to: "/management/requests",
          name: "requests",
          // childs: [
          //   {
          //     title: "درخواست حمل بار",
          //     to: "/management/requests",
          //     name: "requests",
          //   },
          //   // {
          //   //   title: "درخواست های زمان بندی",
          //   //   to: "/management/request-job",
          //   //   name: "requestjobs",
          //   // },
          // ],
        },

        {
          title: "کارتابل",
          childs: [
            {
              title: "کارتابل وضعیت بار",
              to: "/requests",
              name: "requestsmanagements",
            },
            // {
            //   title: "کارتابل پشتیبان",
            //   to: "/request-details",
            //   name: "requestdetailmanagements",
            // },
            {
              title: "پذیرش بار",
              to: "/request-detail-confirmation",
              name: "requestdetailconfirmations",
            },
            {
              title: "پروفایل جامع راننده",
              to: "/management/driver-profile",
              name: "DriverProfile",
            },
          ],
        },
        // {
        //   title: "گزارشات",
        //   childs: [
        //     {
        //       title: "گزارش مالی",
        //       to: "/wallet-report-management",
        //       name: "walletreportmanagements",
        //     },
        //     {
        //       title: "تسویه حساب",
        //       to: "/gateway-transaction",
        //       name: "gatewaytransactions",
        //     },
        //     {
        //       title: "گزارش نوتیفیکیشن",
        //       to: "/notifications/report",
        //       name: "notificationreports",
        //     },
        //     { title: "گزارش کاربران", to: "/user-report", name: "userreports" },
        //   ],
        // },
        // {
        //   title: "مدیریت بارنامه ها",
        //   to: "/cargo",
        //   name: "cargoes",
        // },
        {
          title: "مدیریت سیستم",
          childs: [
            {
              title: "داشبورد مدیریت",
              to: "/management/dashboard",
              name: "adminDashboard",
            },
            { title: "نقش", to: "/management/roles", name: "roles" },
            {
              title: "سطح دسترسی",
              to: "/management/permissions",
              name: "permissions",
            },
            { title: "مدیریت نوع بار", to: "/management/loads", name: "loads" },
            {
              title: "مدیریت ترمینال",
              to: "/management/terminals",
              name: "terminals",
            },
            {
              title: "مدیریت سالن ها",
              to: "/management/salons",
              name: "salons",
            },
            {
              title: "مدیریت نوع ماشین",
              to: "/management/vehicle-types",
              name: "vehicletypes",
            },
            // {
            //   title: "مدیریت گندله",
            //   to: "/management/gondole",
            //   name: "vehicletypes"
            // }
          ],
        },
        {
          title: "مدیریت کاربران",
          childs: [
            { title: "کاربران", to: "/management/users", name: "users" },
            { title: "راننده", to: "/management/drivers", name: "drivers" },
            {
              title: "ماشین آلات",
              to: "/management/vehicles",
              name: "vehicles",
            },
            { title: "صاحب بار", to: "/management/owners", name: "owners" },
            { title: "باربری", to: "/management/carriers", name: "carriers" },
            // {
            //   title: "رانندگان بومی",
            //   to: "/management/native-driver",
            //   name: "nativedrivers",
            // },
            {
              title: "مشتری ها",
              to: "/management/customers",
              name: "customers",
            },
            // {
            //   title: "ارسال پیام خصوصی",
            //   to: "/notifications/send",
            //   name: "notificationsends",
            // },
          ],
        },
        {
          title: "ابزار مدیریت",
          childs: [
            { title: "لیست صفحات", to: "/static-pages", name: "staticpages" },
            { title: "لیست ایکون ها", to: "/app-icons", name: "appicons" },
            {
              title: "مدیریت کیف پول",
              to: "/manage/wallet",
              name: "fixWallet",
            },
            { title: "مدیریت شهر ها", to: "/manage/city", name: "cities" },
            { title: "لیست اخبار", to: "/articles", name: "articles" },
            {
              title: "دسته بندی اخبار",
              to: "/articles/categories",
              name: "categories",
            },
            {
              title: "گزارش مالی",
              to: "/reports/wr1",
              name: "reports",
            },
            {
              title: "گزارش پیامک ها",
              to: "/sms/report",
              name: "sms-report",
            },
            {
              title: "پشتیبانی",
              to: "/support-ticket",
              name: "support",
            },
            {
              title: "ارسال نوتیفیکیشن راننده ",
              to: "/management/notifications",
              name: "notifications",
            },
            //             {
            //   title: "ارسال نوتیفیکیشن پیشرفته",
            //   to: "/management/notifications/advance",
            //   name: "advancenotifications",
            // },
          ],
        },
        {
          title: "کمپین ها",
          childs: [
            {
              title: "کمپین",
              to: "/campaigns",
              name: "campaigns",
            },
            {
              title: "محصولات",
              to: "/campaigns/products",
              name: "products",
            },
            {
              title: "سفارشات",
              to: "/campaigns/orders",
              name: "orders",
            },
          ],
        },
        {
          title: "گزارشات",
          childs: [
            {
              title: "گزارش عمومی ",
              to: "/report/general",
              name: "general",
            },
            {
              title: "گزارش فعالیت رانندگان ",
              to: "/report/activity",
              name: "general",
            },
            {
              title: "گزارش مالی به تفکیک رانندگان ",
              to: "/report/wr3",
              name: "wr3",
            },
            {
              title: "گزارش مالی به تفکیک نوع تراکنش ",
              to: "/report/wr4",
              name: "wr4",
            },
          ],
        },
      ],
      userBalance: "",
      smsCredit: 0,
      settings: {},
    };
  },
  computed: {
    permissionsLoaded() {
      return this.$acl.isReady;
    },
    chunkFullName() {
      const fullName = this.$user.full_name ? this.$user.full_name.trim() : "";
      const firstWord = fullName[0] || "";
      const lastWord = fullName.length ? fullName[fullName.length - 1] : "";

      return firstWord + "‌" + lastWord;
    },
  },
  watch: {
    $route(to, from) {
      this.showItem = false;
    },
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
    var _this = this;
    this.getUserBalance();
    this.getSmsCredit();
    // this.getWalletTransactions()
    this.$root.$on("update:balance", function() {
      _this.getUserBalance();
    });
    // this.$root.$on("update:smscredit", function() {
    //   _this.getSmsCredit();
    // });
  },
  methods: {
    handleCloseModal() {
      this.showItem = false;
    },
    signOut() {
      this.$alert("question", `آیا می خواهید خارج شوید؟`, "", {
        confirmButtonText: "بله",
      }).then((result) => {
        if (result.value) {
          this.$root.$emit("app:logout");
          this.$store.dispatch("logout");
          this.$izitoast("success", "با موفقیت خارج شدید", "موفق");
          this.$router.push("/login");
        }
      });
    },
    checkParentPermissions(_childs) {
      let permitted = false;
      for (let item of _childs) {
        permitted = permitted || this.$acl.can("view", item.name);
      }
      return permitted;
    },
    getAllowedSubMenus(_childs) {
      let allowed = [];
      for (let item of _childs) {
        if (this.$acl.can("view", item.name)) allowed.push(item);
      }
      return allowed;
    },
    openWalletCharge(e) {
      e.preventDefault();
      this.$toggleModal("#charge");
    },
    openSettings() {
      if (this.$acl.isOwner) {
        let user = this.$user;
        this.$root.$emit("setting:modal", user);
        this.$toggleModal("#setting-modal");
      } else
        this.$izitoast(
          "error",
          "ناموفق",
          "تنظیماتی برای شما در نظر گرفته نشده است.",
        );
    },
    async reloadApp() {
      if ("serviceWorker" in navigator) {
        try {
          const names = await caches.keys();

          names.forEach((cacheName) => {
            caches.delete(cacheName);
          });
        } catch {
          //Error Handling
        }

        window.location.reload(true);
      } else {
        window.location.reload(true);
      }
    },
    getUserBalance() {
      this.$persistClient("get", "users/current/balance").then((res) => {
        this.userBalance = res.data.data;
      });
    },
    getWalletTransactions() {
      this.$persistClient("get", "wallets").then((res) => {
        this.userBalance = res.data.data;
      });
    },
    openSmsModal() {
      this.$toggleModal("#sms-modal");
    },
    getSmsCredit() {
      this.$persistClient("get", "/users/current/sms-credit").then((res) => {
        this.smsCredit = res.data.data;
      });
    },
    openChangePassword() {
      this.$toggleModal("#change-password-modal");
    },
  },
};
</script>
<style scoped>
.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
}
.app_overlay {
  width: 100%;
  height: 100%;
  background: #ffffffba;
  position: absolute;
  z-index: 999;
  transition: all 0.3s ease;
}
.notselectable {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
a.router-link-exact-active.router-link-active {
  /* border: 1px solid #51b99c; */
  /* color: #51b99c !important; */
}
.body.rtls .navbar-static-top .navbar-right .dropdown-menu {
  left: 0 !important;
  right: auto !important;
}
.count-info .label {
  right: -31px !important;
  top: -11px !important;
}
.mobile-menu {
  position: fixed;
  background: #f6f7fa;
  z-index: 999;
  top: 0;
  transform: translateX(200px);
  opacity: 0;
  transition: all 0.4s ease;
  box-shadow: 1px 1px 22px -12px #1e7967;
  height: 100%;
  width: 200px;
}
.mobile-menu.show {
  transform: translateX(-16px);
  opacity: 1;
}
.user-avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #14a9d921;
  color: #14a9d9;
}
.user-avatar > strong {
  font-size: 16px;
  font-weight: bold !important;
}
.user-details__links-container {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #fbfbfb;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #100940;
  border: 1px solid #1009401a;
  cursor: pointer;
}
.user-details-container {
  font-size: 12px !important;
  background: #fff;
  color: #100940 !important;
  padding-bottom: 15px !important;
  border-bottom: 1px solid #efefef;
}
.user-details__links-container.close-btn {
  color: #100940;
  display: flex;
  justify-content: center;
  align-items: center;
}
.user-details__balance {
  font-size: 16px;
}
.navbar-expand-lg .navbar-nav {
  gap: 15px;
}

.reload-app {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  color: #fff;
  border-radius: 4px;
  height: 50px;
  padding: 0px 10px;
  font-size: 13px;
  background-color: #14a9d9;
  border-radius: 0;
  margin-left: 20px;
}

.label-blue {
  background-color: #14a9d9;
  color: white;
}
</style>
